exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-gvb-demo-tsx": () => import("./../../../src/pages/gvb-demo.tsx" /* webpackChunkName: "component---src-pages-gvb-demo-tsx" */),
  "component---src-pages-gvb-wiki-tsx": () => import("./../../../src/pages/gvb-wiki.tsx" /* webpackChunkName: "component---src-pages-gvb-wiki-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

